// extracted by mini-css-extract-plugin
module.exports = {"root":"MduNHdo","invert":"_2cR5R1B"};
    if(module.hot) {
      // 1545369444958
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  